import * as types from './types';
import { has } from 'lodash';

export const INITIAL_STATE = {
  loading: false,
  transactionHistoryData: null,
  transactionHistoryPages: -1,
  transactionHistoryDataError: null,
  voidSuccess: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.POS_GET_STUDENT_TRANSACTIONHISTORY_SET_VOID_SUCCESS:
      return {
        ...state,
        voidSuccess: payload,
      };
    case types.POS_GET_STUDENT_TRANSACTIONHISTORY:
      return {
        ...state,
        transactionHistoryData: payload.Data,
        transactionHistoryPages: payload.Pages,
      };
    case types.POS_GET_STUDENT_TRANSACTIONHISTORY_CLEAR_ERROR:
      return {
        ...state,
        transactionHistoryDataError: null,
      };
    case types.POS_GET_STUDENT_TRANSACTIONHISTORY_ERROR:
      const hardCodedError = {
        Title: 'Error',
        Message:
          'An error occurred while fetching the student history. Please try again.',
      };
      if (has(payload, 'response.data')) {
        if (payload.response.data.Errors === undefined) {
          return {
            ...state,
            transactionHistoryDataError: hardCodedError,
          };
        }

        const transactionHistoryDataError = payload.response.data.Errors[0];

        return {
          ...state,
          transactionHistoryDataError,
        };
      }

      return {
        ...state,
        transactionHistoryDataError: hardCodedError,
      };

    case types.POS_GET_STUDENT_LOADING_TRANSACTIONHISTORY:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/history/state/reducer.js